import React from 'react';
import 'twin.macro';
import { Disclosure } from '@headlessui/react';

import CollapseLink from './CollapseLink';

interface CollapseProps {
  title: string;
  items: {
    title: string;
    to: string;
  }[];
}

const Collapse: React.FC<CollapseProps> = ({ title, items }) => (
  <Disclosure>
    <Disclosure.Button tw="text-xl md:(text-2xl) lg:(text-3xl) text-white rounded-lg font-bold block w-full py-3 px-4 text-center hover:(underline text-blue-100) focus:(outline-none ring-4 ring-green ring-opacity-60)">
      {title}
    </Disclosure.Button>
    <Disclosure.Panel tw="grid gap-6 p-6 w-full md:(grid-cols-2) lg:(grid-cols-3)">
      {items.map((item) => (
        <CollapseLink to={item.to} key={item.to}>
          {item.title}
        </CollapseLink>
      ))}
    </Disclosure.Panel>
  </Disclosure>
);

export default Collapse;
